export const environment = {
  firebase: {
    projectId: 'explorer-f45e6',
    appId: '1:466547680272:web:93721e377d2d6e51731695',
    storageBucket: 'explorer-f45e6',
    apiKey: 'AIzaSyBSTzKE8t7zUir0_t2BcEftWeqcgzsqfMM',
    authDomain: 'explorer-f45e6.firebaseapp.com',
    messagingSenderId: '466547680272',
  },
  appCheckSiteKey: '6LepiDAsAAAAALCGO9vO02JJyXQMt2hluhX-gBED',
  // Firebase emulator hosts, set only by the emulator build (e2e tests).
  emulators: null as null | { auth: string; firestore: { host: string; port: number }; functions: { host: string; port: number } },
};
